/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AutoDecisioningOptions } from './AutoDecisioningOptions';
import {
    AutoDecisioningOptionsFromJSON,
    AutoDecisioningOptionsFromJSONTyped,
    AutoDecisioningOptionsToJSON,
    AutoDecisioningOptionsToJSONTyped,
} from './AutoDecisioningOptions';

/**
 * 
 * @export
 * @interface GetAutoDecisioningOptions200Response
 */
export interface GetAutoDecisioningOptions200Response {
    /**
     * 
     */
    data?: AutoDecisioningOptions;
}

/**
 * Check if a given object implements the GetAutoDecisioningOptions200Response interface.
 */
export function instanceOfGetAutoDecisioningOptions200Response(value: object): value is GetAutoDecisioningOptions200Response {
    return true;
}

export function GetAutoDecisioningOptions200ResponseFromJSON(json: any): GetAutoDecisioningOptions200Response {
    return GetAutoDecisioningOptions200ResponseFromJSONTyped(json, false);
}

export function GetAutoDecisioningOptions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAutoDecisioningOptions200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : AutoDecisioningOptionsFromJSON(json['data']),
    };
}

export function GetAutoDecisioningOptions200ResponseToJSON(json: any): GetAutoDecisioningOptions200Response {
    return GetAutoDecisioningOptions200ResponseToJSONTyped(json, false);
}

export function GetAutoDecisioningOptions200ResponseToJSONTyped(value?: GetAutoDecisioningOptions200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': AutoDecisioningOptionsToJSON(value['data']),
    };
}

